import Vue, { ComponentOptions, CreateElement, VNode } from "vue";
import AppSelect from "~shared/components/AppSelect.vue";
import AppInput from "~shared/components/AppInput.vue";

export interface FieldSelectItem {
  label: string;
  value: string;
}

export type EntityListSearchComponent = Vue;

export class EntityListSearchBuilder {
  private _fieldsSelectItems: FieldSelectItem[] | null = null;

  private _placeholder = "Type to search...";

  private _debounce = 0;

  private buildFieldSelect(h: CreateElement, component: EntityListSearchComponent): VNode | null {
    if (!this._fieldsSelectItems || !this._fieldsSelectItems.length) {
      return null;
    }

    component.$emit("onSearchByChanged", this._fieldsSelectItems[0]?.value);

    return h(AppSelect, {
      attrs: {
        value: this._fieldsSelectItems[0]?.value,
        items: this._fieldsSelectItems,
        itemValue: "value",
        itemText: "label",
      },
      staticClass: "entity-list-search-by",
      on: {
        input(value) {
          component.$emit("onSearchByChanged", value);
        },
      },
    });
  }

  private buildTextField(h: CreateElement, component: EntityListSearchComponent): VNode {
    return h(AppInput, {
      attrs: {
        placeholder: this._placeholder,
        debounce: this._debounce,
      },
      staticClass: "entity-list-search-value",
      on: {
        input(value) {
          component.$emit("onSearchValueChanged", value);
        },
      },
    });
  }

  public withFieldsSelect(fieldsSelectItems: FieldSelectItem[]): EntityListSearchBuilder {
    this._fieldsSelectItems = fieldsSelectItems;
    return this;
  }

  public withPlaceholder(placeholder: string): EntityListSearchBuilder {
    this._placeholder = placeholder;
    return this;
  }

  public withDebounce(debounce: number): EntityListSearchBuilder {
    this._debounce = debounce;
    return this;
  }

  public build(): ComponentOptions<EntityListSearchComponent> {
    const $ = this;

    return {
      render(this: EntityListSearchComponent, h: CreateElement): VNode {
        return h(
          "div",
          {
            staticClass: "entity-list-search",
          },
          [$.buildFieldSelect(h, this), $.buildTextField(h, this)]
        );
      },
    };
  }
}
